
export enum ActionType {
    fetch_product = "FETCH_PRODUCT",
    fetch_cart = "FETCH_CART",
    add_cart = "ADD_CART",
    fetch_details = "FETCH_DETAILS",
    del_cart = "DEL_CART",
    adjust_qty = "ADJUST_QTY",
    del_all = "DEL_ALL",
    inc_qty = "INC_QTY",
    dec_qty = "DEC_QTY",
    login_start = "LOGIN_START",
    login_success = "LOGIN_SUCCESS",
    login_failure = "LOGIN_FAILURE",
    log_out = "LOG_OUT"
}